export const futuristicInputStyles = {
    container: {
      // Gradient remains for the border effect via padding
      background:
        "linear-gradient(45deg, rgba(59, 130, 246, 0.6), rgba(147, 51, 234, 0.5), rgba(59, 130, 246, 0.6))", // Slightly adjusted opacity
      backgroundSize: "200% 200%",
      // Keep pulse-glow animation for the border glow
      animation:
        "gradient-animation 6s ease infinite, pulse-glow 4s ease-in-out infinite",
      padding: "1px", // This creates the border effect
      overflow: "hidden",
      borderRadius: "0.5rem",
      transition: "box-shadow 0.3s ease",
    },
    shimmer: {
      // Shimmer is less relevant now but kept subtle
      position: "absolute",
      inset: 0,
      opacity: 0.1,
      background:
        "linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)",
      width: "100%",
      height: "100%",
      animation: "shimmer 4s infinite",
      pointerEvents: "none",
    },
    input: {
      width: "100%",
      paddingLeft: "0.75rem",
      paddingRight: "2.5rem",
      paddingTop: "0.5rem",
      paddingBottom: "0.5rem",
      borderRadius: "0.5rem", // Match container radius
      backgroundColor: "rgba(255, 255, 255, 0.9)", // Near-opaque white background
      // Removed backdropFilter to ensure simple background
      border: "none",
      outline: "none",
      fontSize: "0.875rem",
      color: "#1f2937", // Dark text color (gray-800)
      textShadow: "none", // Removed text shadow for cleaner look
      caretColor: "#3b82f6", // Blue caret color (blue-500)
      "::placeholder": {
        color: "#6b7280", // Gray placeholder color (gray-500)
      },
    },
    button: {
      position: "absolute",
      right: "0.25rem",
      top: "50%",
      transform: "translateY(-50%)",
      width: "2rem",
      height: "2rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "9999px",
      backgroundColor: "rgba(0, 0, 0, 0.05)", // Subtle dark background for contrast
      color: "#4b5563", // Darker gray icon color (gray-600)
      boxShadow: "none", // Removed button shadow
      zIndex: 10,
      transition: "background-color 0.3s, color 0.3s",
      ":hover": {
        backgroundColor: "rgba(0, 0, 0, 0.1)",
        color: "#1f2937", // Darker gray icon on hover (gray-800)
      },
    },
    keyframes: `
      @keyframes gradient-animation {
        0% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
      }
      @keyframes shimmer {
        0% { transform: translateX(-100%) skewX(-15deg); }
        100% { transform: translateX(200%) skewX(-15deg); }
      }
      @keyframes pulse-glow {
        // Adjusted glow animation for subtlety
        0% { box-shadow: 0 0 8px rgba(59, 130, 246, 0.3), 0 0 15px rgba(147, 51, 234, 0.2); }
        50% { box-shadow: 0 0 12px rgba(59, 130, 246, 0.4), 0 0 20px rgba(147, 51, 234, 0.3); }
        100% { box-shadow: 0 0 8px rgba(59, 130, 246, 0.3), 0 0 15px rgba(147, 51, 234, 0.2); }
      }
    `,
  };

export default function TextBox({inputTaskString, setInputTaskString, handleTaskSubmit, isSubmittingTask, futuristicInputStyles}) {
  return (
    <form onSubmit={handleTaskSubmit} className="relative pt-2">
          <div
            className="relative w-full"
            style={futuristicInputStyles.container}
          >
            <div style={futuristicInputStyles.shimmer}></div>
            <input
              type="text"
              placeholder="Type and press enter to add task..."
              value={inputTaskString}
              onChange={(e) => setInputTaskString(e.target.value)}
              style={futuristicInputStyles.input}
            />
            <button
              type="submit"
              style={futuristicInputStyles.button}
              disabled={isSubmittingTask}
            >
              {isSubmittingTask ? (
                <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-gray-400"></div>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-4 h-4"
                >
                  <path d="M3.478 2.404a.75.75 0 0 0-.926.941l2.432 7.905H13.5a.75.75 0 0 1 0 1.5H4.984l-2.432 7.905a.75.75 0 0 0 .926.94 60.519 60.519 0 0 0 18.445-8.986.75.75 0 0 0 0-1.218A60.517 60.517 0 0 0 3.478 2.404Z" />
                </svg>
              )}
            </button>
          </div>
        </form>
  );
}